import { render, staticRenderFns } from "./CommercialForSale.vue?vue&type=template&id=94a84006&scoped=true&"
import script from "./CommercialForSale.vue?vue&type=script&lang=ts&"
export * from "./CommercialForSale.vue?vue&type=script&lang=ts&"
import style0 from "./CommercialForSale.vue?vue&type=style&index=0&id=94a84006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a84006",
  null
  
)

export default component.exports